<template>
  <div class="input-options-data-dialog">
    <div class="setting-item mb40">
      <el-collapse v-model="activeNames" style="width: 100%">
        <el-collapse-item @mousedown.native="collapseMouseDown($event, '1')" title="数据源" name="1" v-if="searchComponentPlugin">
          <div class="data-source-type">
            <cx-slider :value.sync="dataType" :options="dataOptions" :height="32" />
          </div>
        </el-collapse-item>
        <el-collapse-item @mousedown.native="collapseMouseDown($event, '2')" title="提示语" name="2" v-if="dataType === '1'">
          <div class="content">
            <div class="content-item mb16 verticallyCenter">
              <label class="font14 mr16">类型</label>
              <el-select class="flex1" style="height: 32px" v-model="inputTypeVal">
                <el-option v-for="(item, index) in inputTypeList" :key="index" :label="item.title" :value="item.value">
                  {{ item.title }}
                </el-option>
              </el-select>
            </div>
            <div class="content-item mb16">
              <!-- <label class="font14 mb8">提示语文案</label> -->
              <el-input class="text-inp" v-model="placeholder" type="textarea" resize="none"></el-input>
            </div>
            <!-- <div class="content-item mb16">
              <el-checkbox class="" v-model="ifAutoFocus">自动聚焦</el-checkbox>
            </div> -->
          </div>
        </el-collapse-item>
        <el-collapse-item @mousedown.native="collapseMouseDown($event, '3')" title="数据绑定" name="3" v-if="dataType === '3'">
          <div>
            <div class="mapping_content">
              <div class="select-name">提示语</div>
            </div>
            <el-checkbox class="mt8" v-model="emptyDataShowLocal">数据为空时显示自定义内容</el-checkbox>
            <div class="mapping_content bgColor mt8" v-if="emptyDataShowLocal">
              <el-input v-model="emptyPlaceholder" type="text"></el-input>
            </div>
          </div>
        </el-collapse-item>
      </el-collapse>
    </div>
  </div>
</template>

<script>
import { findLayoutOptions } from "utils"
export default {
  name: "input-options-data",
  components: {},
  props: {
    options: {
      type: Object
    }
  },
  data() {
    return {
      activeNames: ["1", "2", "3"],
      collapseActiveNames: [],
      inputTypeList: [
        {
          title: "文本",
          value: "text"
        },
        {
          title: "邮箱",
          value: "email"
        },
        {
          title: "密码",
          value: "password"
        },
        {
          title: "数字",
          value: "number"
        }
      ],
      dataOptions: [
        { value: "1", title: "本地数据" }, 
        { value: "3", title: "数据绑定" }
      ],
      datas: []
    }
  },
  comments: {},
  mounted() {},
  computed: {
    ids() {
      return this.$store.state.states.activeID
    },
    layoutOptions() {
      return findLayoutOptions(this, this.ids)
    },
    searchComponentPlugin() {
      return this.layoutOptions?.pluginName?.includes("searchComponentPlugin")
    },
    placeholder: {
      get() {
        return this.options.placeholder ? this.options.placeholder : ""
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "placeholder", false)
      }
    },
    emptyPlaceholder: {
      get() {
        return this.options.emptyPlaceholder ? this.options.emptyPlaceholder : ""
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "emptyPlaceholder", false)
      }
    },
    inputValue: {
      get() {
        return this.options.inputValue ? this.options.inputValue : ""
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "inputValue", false)
      }
    },
    inputTypeVal: {
      get() {
        return this.options.inputTypeVal ? this.options.inputTypeVal : ""
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "inputTypeVal", false)
      }
    },
    ifAutoFocus: {
      get() {
        return this.options.ifAutoFocus ? this.options.ifAutoFocus : false
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "ifAutoFocus", false)
      }
    },
    dataType: {
      get() {
        return this.options.dataType || "1"
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "dataType", false)
        if (newVal === "3") {
          this.getSearchInfo()
        }
      }
    },
    emptyDataShowLocal: {
      get() {
        return this.options.emptyDataShowLocal
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "emptyDataShowLocal", false, null)
      }
    },
  },
  methods: {
    collapseMouseDown($event, val) {
      if ($event.target.classList[0] === "el-collapse-item__header") {
        const _index = this.collapseActiveNames.findIndex(it => it === val)
        _index === -1 ? this.collapseActiveNames.push(val) : ""
      }
    },
    getSearchInfo() {
      const { appId, activeSearchData } = this.layoutOptions
      if (this.searchComponentPlugin && appId) {
        this.placeholder = activeSearchData && activeSearchData.linkDes ? activeSearchData.linkDes : this.emptyDataShowLocal ? this.emptyPlaceholder : ""
      } else {
        this.placeholder = ""
      }
    },
  }
}
</script>

<style lang="scss" scoped>
.text-inp ::v-deep.el-textarea__inner {
  color: rgba(0, 0, 0, 0.8);
  background-color: #f3f3f3;
  border: none;
  padding: 6px 12px;
}
.mapping_content {
  padding: 8px;
  color: rgba(0, 0, 0, 0.8);
  border-radius: 4px;
  border: 1px solid rgba(233, 233, 233, 1);
  background-color: rgba(247, 248, 250, 1);
  &.bgColor {
    background-color: rgba(251, 252, 253, 1);
  }
}

.select-name {
  font-size: 13px;
  border-radius: 4px;
  height: 32px;
  line-height: 22px;
  padding: 5px 0 5px 12px;
  background-color: rgba(36, 0, 255, 0.1);
  color: rgba(36, 0, 255, 1);
  box-shadow: 0px 0px 0px 1px rgba(36, 0, 255, 0.16) inset;
}
</style>
